import * as types from "./salesTaxesActionTypes";

export default function enumReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_TAXES_SUCCESS: {
      let newData = {};
      newData = { ...state, items: [...action.payload.data] };
      return { ...newData };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/salesTaxesReducer.js